import Booking from '@/models/booking/Booking'
import ProductSupplier from '@/models/supplier/ProductSupplier'

export default class OrderLine {
  public id: number
  public orderId: number
  public costAmount: number
  public netAmount: number
  public number: number

  public productId: number
  public productType: number
  public supplierId: number
  public fromLocationId: number

  public priceExchanged: number
  public grossExchanged: string
  public productName: string
  public discountType: string
  public discountValue: string
  public vatPercent: string
  public vatCode: string
  public account: string
  public source: string
  public wheelGroup: string
  public comment: string

  public productSupplier: ProductSupplier = null

  public constructor(data: Record<string, unknown> = null) {
    if (!data) {
      data = {}
    }
    this.id = data.id ? (data.id as number) : null
    this.orderId = data.orderId ? (data.orderId as number) : null
    this.costAmount = data.costAmount ? (data.costAmount as number) : null
    this.netAmount = data.netAmount ? (data.netAmount as number) : null
    this.number = data.number ? (data.number as number) : null

    this.productId = data.productId ? (data.productId as number) : null
    this.productType = data.productType ? (data.productType as number) : null
    this.supplierId = data.supplierId ? (data.supplierId as number) : null
    this.fromLocationId = data.fromLocationId ? (data.fromLocationId as number) : null

    this.priceExchanged = data.priceExchanged ? (data.priceExchanged as number) : null
    this.grossExchanged = data.grossExchanged ? (data.grossExchanged as string) : null
    this.productName = data.productName ? (data.productName as string) : null
    this.discountType = data.discountType ? (data.discountType as string) : null
    this.discountValue = data.discountValue ? (data.discountValue as string) : null
    this.vatPercent = data.vatPercent ? (data.vatPercent as string) : null
    this.vatCode = data.vatCode ? (data.vatCode as string) : null
    this.account = data.account ? (data.account as string) : null
    this.source = data.source ? (data.source as string) : null
    this.wheelGroup = data.wheelGroup ? (data.wheelGroup as string) : null
    this.comment = data.comment ? (data.comment as string) : null

    this.productSupplier = data.productSupplier
      ? new ProductSupplier(data.productSupplier as Record<string, unknown>)
      : null
  }
}
